var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var PacemCylinderElement_1;
import { CustomElement, P, Watch, PropertyConverters } from '@pacem/pacem-core';
import { computeSharpVertexNormals } from '../types';
import { MeshGeometry } from '../geometry';
import { Pacem3DPrimitiveElement } from './primitive';
import { TAG_MIDDLE_NAME, DEG2RAD } from '../constants';
//namespace Pacem.Components.Drawing3D {
let PacemCylinderElement = PacemCylinderElement_1 = class PacemCylinderElement extends Pacem3DPrimitiveElement {
    static createMeshGeometry(radius = 1, height = 1, sides = 18, heightSegments = 5, capSegments = 1) {
        const r = radius;
        const nodes = [], uv = [], indices = [];
        const theta = DEG2RAD * (360.0 / sides);
        // top & bottom vertices (pivot @(0,0,0))
        nodes.push({ x: .0, y: height, z: .0 });
        nodes.push({ x: .0, y: .0, z: .0 });
        // ======================================
        // cap loops
        const capRadius = r / capSegments;
        for (let j = 1; j <= capSegments; j++) {
            //int j_prev = j - 1;
            var rho = capRadius * j;
            for (var i = 0; i < sides; i++) {
                const startIndex = 2 + 2 * sides * (j - 1);
                const A = i == 0 ? startIndex + 2 * (sides - 1) : startIndex + 2 * (i - 1);
                const B = startIndex + 2 * i;
                const u = Math.cos(theta * i);
                const v = -Math.sin(theta * i);
                const u_prev = Math.cos(theta * (i - 1.0));
                const v_prev = -Math.sin(theta * (i - 1.0));
                const x = rho * u;
                const z = rho * v;
                const topPoint = { x, y: height, z };
                const bottomPoint = { x, y: .0, z };
                //
                nodes.push(topPoint);
                nodes.push(bottomPoint);
                // coordinates & texture
                const factor = .5 * rho / r;
                const uB = u * factor;
                const vB = v * factor;
                const uA = u_prev * factor;
                const vA = v_prev * factor;
                if (j == 1) {
                    const faceIndicesTop = [0 /* top vertex*/, A, B];
                    const faceIndicesBottom = [1 /* bottom vertex*/, B + 1, A + 1];
                    // texture
                    const uvTop = [
                        { x: .5, y: .5 },
                        { x: .5 + uA, y: .5 - vA },
                        { x: 0.5 + uB, y: .5 - vB }
                    ];
                    const uvBottom = [
                        { x: .5, y: .5 },
                        { x: 0.5 + uB, y: .5 + vB },
                        { x: .5 + uA, y: .5 + vA }
                    ];
                    // faces
                    indices.push(...faceIndicesTop);
                    indices.push(...faceIndicesBottom);
                    // texture
                    for (let i = 0; i < uvTop.length; i++)
                        uv.push(uvTop[i]);
                    for (let i = 0; i < uvBottom.length; i++)
                        uv.push(uvBottom[i]);
                }
                else {
                    const startIndexPrevLoop = 2 + 2 * sides * (j - 2);
                    const D = i == 0 ? startIndexPrevLoop + 2 * (sides - 1) : startIndexPrevLoop + 2 * (i - 1);
                    const C = startIndexPrevLoop + 2 * i;
                    // coordinates & texture
                    const factor0 = .5 * ((j - 1.0) / capSegments);
                    const uC = u * factor0;
                    const vC = v * factor0;
                    const uD = u_prev * factor0;
                    const vD = v_prev * factor0;
                    const uvA = { x: .5 + uA, y: .5 - vA };
                    const uvB = { x: .5 + uB, y: .5 - vB };
                    const uvC = { x: .5 + uC, y: .5 - vC };
                    const uvD = { x: .5 + uD, y: .5 - vD };
                    const uvA2 = { x: .5 + uA, y: .5 + vA };
                    const uvB2 = { x: .5 + uB, y: .5 + vB };
                    const uvC2 = { x: .5 + uC, y: .5 + vC };
                    const uvD2 = { x: .5 + uD, y: .5 + vD };
                    // top
                    indices.push(A);
                    indices.push(B);
                    indices.push(D);
                    indices.push(D);
                    indices.push(B);
                    indices.push(C);
                    // bottom
                    indices.push(C + 1);
                    indices.push(B + 1);
                    indices.push(A + 1);
                    indices.push(C + 1);
                    indices.push(A + 1);
                    indices.push(D + 1);
                    // textures top
                    uv.push(uvA);
                    uv.push(uvB);
                    uv.push(uvD);
                    uv.push(uvD);
                    uv.push(uvB);
                    uv.push(uvC);
                    // texture bottom
                    uv.push(uvC2);
                    uv.push(uvB2);
                    uv.push(uvA2);
                    uv.push(uvC2);
                    uv.push(uvA2);
                    uv.push(uvD2);
                }
            }
        }
        // ======================================
        // side loops
        const sideStartIndex = 2 + 2 * sides * (capSegments);
        const capLastIndex = 2 + 2 * sides * (capSegments - 1);
        const fU = 1.0 / sides;
        const fV = 1.0 / heightSegments;
        for (let j = 1; j <= heightSegments; j++) {
            for (let i = 0; i < sides; i++) {
                if (j != heightSegments) {
                    var x = r * Math.cos(theta * i);
                    var z = -r * Math.sin(theta * i);
                    var y = (height * j) / heightSegments;
                    //
                    nodes.push({ x, y, z });
                }
                const i_prev = i == 0 ? sides - 1 : i - 1;
                const A = j == 1 ? capLastIndex + 2 * i_prev + 1 : sideStartIndex + sides * (j - 2) + i_prev;
                const B = j == 1 ? capLastIndex + 2 * i + 1 : sideStartIndex + sides * (j - 2) + i;
                const C = j == heightSegments ? capLastIndex + 2 * i : sideStartIndex + sides * (j - 1) + i;
                const D = j == heightSegments ? capLastIndex + 2 * i_prev : sideStartIndex + sides * (j - 1) + i_prev;
                const u_prev = i_prev * fU;
                const v_prev = (j - 1) * fV;
                const u = i == 0 ? 1.0 : i * fU;
                const v = j * fV;
                const uvA = { x: u_prev, y: v_prev };
                const uvB = { x: u, y: v_prev };
                const uvC = { x: u, y: v };
                const uvD = { x: u_prev, y: v };
                indices.push(A);
                indices.push(B);
                indices.push(C);
                indices.push(A);
                indices.push(C);
                indices.push(D);
                //
                uv.push(uvA);
                uv.push(uvB);
                uv.push(uvC);
                uv.push(uvA);
                uv.push(uvC);
                uv.push(uvD);
            }
        }
        // put the whole thing together
        const geom = new MeshGeometry(nodes, indices, uv);
        geom.key = `cylinder_${radius}x${height}_s${sides}_h${heightSegments}_c${capSegments}`;
        computeSharpVertexNormals(geom);
        // TODO: barycenter, boundingBox, boundingSphere
        return geom;
    }
    createDefaultGeometry() {
        return PacemCylinderElement_1.createMeshGeometry();
    }
    propertyChangedCallback(name, old, val, first) {
        super.propertyChangedCallback(name, old, val, first);
        switch (name) {
            case 'radius':
            case 'height':
            case 'sides':
            case 'heightSegments':
            case 'capSegments':
                this.geometry = PacemCylinderElement_1.createMeshGeometry(this.radius, this.height, this.sides, this.heightSegments, this.capSegments);
                break;
        }
    }
};
__decorate([
    Watch({ emit: false, converter: PropertyConverters.Number })
], PacemCylinderElement.prototype, "radius", void 0);
__decorate([
    Watch({ emit: false, converter: PropertyConverters.Number })
], PacemCylinderElement.prototype, "height", void 0);
__decorate([
    Watch({ emit: false, converter: PropertyConverters.Number })
], PacemCylinderElement.prototype, "sides", void 0);
__decorate([
    Watch({ emit: false, converter: PropertyConverters.Number })
], PacemCylinderElement.prototype, "heightSegments", void 0);
__decorate([
    Watch({ emit: false, converter: PropertyConverters.Number })
], PacemCylinderElement.prototype, "capSegments", void 0);
PacemCylinderElement = PacemCylinderElement_1 = __decorate([
    CustomElement({ tagName: P + '-' + TAG_MIDDLE_NAME + '-primitive-cylinder' })
], PacemCylinderElement);
export { PacemCylinderElement };
